"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledRightRailFlyoutItemLabel = exports.StyledRightRailFlyoutItemIcon = exports.StyledRightRailFlyoutItem = exports.StyledRightRailFlyoutContainer = exports.StyledRatioBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _RatioBox = _interopRequireDefault(require("../../RatioBox/RatioBox.index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var _default = {};
exports["default"] = _default;

var StyledRightRailFlyoutItem = _styledComponents["default"].div.withConfig({
  displayName: "RightRailFlyoutItemstyles__StyledRightRailFlyoutItem",
  componentId: "sc-ll950j-0"
})(["", " display:table;transition:margin-left ease-in-out 0.3s;", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    ma0 pa0\n    ", "\n  "])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return "bg-".concat(backgroundColor);
}), function (_ref2) {
  var containerWidth = _ref2.containerWidth,
      hover = _ref2.hover,
      squareWidth = _ref2.squareWidth;
  return hover && "\n    &:hover {\n      margin-left: -".concat(containerWidth - squareWidth, "px;\n    }\n  ");
});

exports.StyledRightRailFlyoutItem = StyledRightRailFlyoutItem;

var StyledRightRailFlyoutContainer = _styledComponents["default"].div.withConfig({
  displayName: "RightRailFlyoutItemstyles__StyledRightRailFlyoutContainer",
  componentId: "sc-ll950j-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["flex"]))));

exports.StyledRightRailFlyoutContainer = StyledRightRailFlyoutContainer;

var StyledRightRailFlyoutItemIcon = _styledComponents["default"].div.withConfig({
  displayName: "RightRailFlyoutItemstyles__StyledRightRailFlyoutItemIcon",
  componentId: "sc-ll950j-2"
})(["", " flex-grow:0;border-color:rgba(255,255,255,0.5);", ";"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-shrink-0 flex justify-center items-center w-100 br white\n    ", ";\n  "])), function (_ref3) {
  var _ref3$theme = _ref3.theme;
  _ref3$theme = _ref3$theme === void 0 ? {} : _ref3$theme;
  var appearance = _ref3$theme.rightRailFlyout.appearance;
  return "\n      ".concat(appearance, "\n    ");
}), function (_ref4) {
  var squareWidth = _ref4.squareWidth;
  return "\n    width: ".concat(squareWidth, "px;\n  ");
});

exports.StyledRightRailFlyoutItemIcon = StyledRightRailFlyoutItemIcon;

var StyledRightRailFlyoutItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "RightRailFlyoutItemstyles__StyledRightRailFlyoutItemLabel",
  componentId: "sc-ll950j-3"
})(["", " a{", " &:hover{text-decoration:none;}}"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["w-100 ma0 pv2 ph3 flex items-center nowrap"]))), (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["white fw7 lh-solid f6 ma0 pa0"]))));

exports.StyledRightRailFlyoutItemLabel = StyledRightRailFlyoutItemLabel;
var StyledRatioBox = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "RightRailFlyoutItemstyles__StyledRatioBox",
  componentId: "sc-ll950j-4"
})(["", " & [class*=\"StyledAspectRatioObject\"]{", "}"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["w-100"]))), (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["flex items-center justify-center"]))));
exports.StyledRatioBox = StyledRatioBox;